/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignInboundFaxDto,
  ErrorResponse,
  InboundFaxListResponseDto,
  InboundFaxResponseDto,
  InboundFaxUrlResponseDto,
  OutboundFaxResponseDto,
} from '../models/index';
import {
    AssignInboundFaxDtoFromJSON,
    AssignInboundFaxDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    InboundFaxListResponseDtoFromJSON,
    InboundFaxListResponseDtoToJSON,
    InboundFaxResponseDtoFromJSON,
    InboundFaxResponseDtoToJSON,
    InboundFaxUrlResponseDtoFromJSON,
    InboundFaxUrlResponseDtoToJSON,
    OutboundFaxResponseDtoFromJSON,
    OutboundFaxResponseDtoToJSON,
} from '../models/index';

export interface AssignInboundFaxRequest {
    id: string;
    assignInboundFaxDto: AssignInboundFaxDto;
    practiceId?: string;
}

export interface GetInboundFaxRequest {
    id: string;
    practiceId?: string;
}

export interface GetInboundFaxUrlRequest {
    id: string;
    practiceId?: string;
}

export interface ListInboundFaxesRequest {
    practiceId?: string;
    page?: number;
    pageSize?: number;
    fromNumber?: string;
    fromDate?: string;
    toDate?: string;
}

export interface SendOutboundFaxRequest {
    to: string;
    headerText?: string;
}

export interface UnassignInboundFaxRequest {
    id: string;
    practiceId?: string;
}

/**
 * 
 */
export class FaxesApi extends runtime.BaseAPI {

    /**
     * Assigns a practice-scoped inbound fax to a patient in the same practice. The fax remains visible in the practice inbox.
     * Assign inbound fax to a patient
     */
    async assignInboundFaxRaw(requestParameters: AssignInboundFaxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InboundFaxResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling assignInboundFax().'
            );
        }

        if (requestParameters['assignInboundFaxDto'] == null) {
            throw new runtime.RequiredError(
                'assignInboundFaxDto',
                'Required parameter "assignInboundFaxDto" was null or undefined when calling assignInboundFax().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['practiceId'] != null) {
            queryParameters['practiceId'] = requestParameters['practiceId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/faxes/inbound/{id}/assign`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: AssignInboundFaxDtoToJSON(requestParameters['assignInboundFaxDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InboundFaxResponseDtoFromJSON(jsonValue));
    }

    /**
     * Assigns a practice-scoped inbound fax to a patient in the same practice. The fax remains visible in the practice inbox.
     * Assign inbound fax to a patient
     */
    async assignInboundFax(requestParameters: AssignInboundFaxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InboundFaxResponseDto> {
        const response = await this.assignInboundFaxRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get inbound fax detail
     */
    async getInboundFaxRaw(requestParameters: GetInboundFaxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InboundFaxResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getInboundFax().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['practiceId'] != null) {
            queryParameters['practiceId'] = requestParameters['practiceId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/faxes/inbound/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InboundFaxResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get inbound fax detail
     */
    async getInboundFax(requestParameters: GetInboundFaxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InboundFaxResponseDto> {
        const response = await this.getInboundFaxRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a 15-minute signed GCS URL with inline PDF response hints.
     * Get signed PDF URL for inbound fax
     */
    async getInboundFaxUrlRaw(requestParameters: GetInboundFaxUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InboundFaxUrlResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getInboundFaxUrl().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['practiceId'] != null) {
            queryParameters['practiceId'] = requestParameters['practiceId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/faxes/inbound/{id}/url`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InboundFaxUrlResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns a 15-minute signed GCS URL with inline PDF response hints.
     * Get signed PDF URL for inbound fax
     */
    async getInboundFaxUrl(requestParameters: GetInboundFaxUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InboundFaxUrlResponseDto> {
        const response = await this.getInboundFaxUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a paginated, practice-scoped inbound fax inbox. Providers use the practiceId from their token. Admin users must pass practiceId as a query param.
     * List inbound faxes for a practice
     */
    async listInboundFaxesRaw(requestParameters: ListInboundFaxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InboundFaxListResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['practiceId'] != null) {
            queryParameters['practiceId'] = requestParameters['practiceId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['fromNumber'] != null) {
            queryParameters['fromNumber'] = requestParameters['fromNumber'];
        }

        if (requestParameters['fromDate'] != null) {
            queryParameters['fromDate'] = requestParameters['fromDate'];
        }

        if (requestParameters['toDate'] != null) {
            queryParameters['toDate'] = requestParameters['toDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/faxes/inbound`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InboundFaxListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns a paginated, practice-scoped inbound fax inbox. Providers use the practiceId from their token. Admin users must pass practiceId as a query param.
     * List inbound faxes for a practice
     */
    async listInboundFaxes(requestParameters: ListInboundFaxesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InboundFaxListResponseDto> {
        const response = await this.listInboundFaxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Provider-only multipart endpoint. Accepts one PDF and one E.164 recipient, archives the PDF in GCS, submits the fax to Sinch, and returns the outbound fax job.
     * Send an outbound fax
     */
    async sendOutboundFaxRaw(requestParameters: SendOutboundFaxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutboundFaxResponseDto>> {
        if (requestParameters['to'] == null) {
            throw new runtime.RequiredError(
                'to',
                'Required parameter "to" was null or undefined when calling sendOutboundFax().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['to'] != null) {
            formParams.append('to', requestParameters['to'] as any);
        }

        if (requestParameters['headerText'] != null) {
            formParams.append('headerText', requestParameters['headerText'] as any);
        }

        const response = await this.request({
            path: `/faxes/outbound`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutboundFaxResponseDtoFromJSON(jsonValue));
    }

    /**
     * Provider-only multipart endpoint. Accepts one PDF and one E.164 recipient, archives the PDF in GCS, submits the fax to Sinch, and returns the outbound fax job.
     * Send an outbound fax
     */
    async sendOutboundFax(requestParameters: SendOutboundFaxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutboundFaxResponseDto> {
        const response = await this.sendOutboundFaxRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Clears patientId from a practice-scoped inbound fax. The fax remains visible in the practice inbox.
     * Remove inbound fax patient assignment
     */
    async unassignInboundFaxRaw(requestParameters: UnassignInboundFaxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InboundFaxResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling unassignInboundFax().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['practiceId'] != null) {
            queryParameters['practiceId'] = requestParameters['practiceId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/faxes/inbound/{id}/assign`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InboundFaxResponseDtoFromJSON(jsonValue));
    }

    /**
     * Clears patientId from a practice-scoped inbound fax. The fax remains visible in the practice inbox.
     * Remove inbound fax patient assignment
     */
    async unassignInboundFax(requestParameters: UnassignInboundFaxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InboundFaxResponseDto> {
        const response = await this.unassignInboundFaxRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
